export function updateTranslationSelect() {
    let translationSelect = $('.js-attribute-key-select');

    translationSelect.change(function () {
        let instance = translationSelect.data('instance');
        let productAttributeKey = translationSelect.val();
        let table = $('.js-translation-table');
        let inputs = table.find('input');
        let inputArray = getInputData(inputs);
        let languageArray = [];

        $.each(inputArray, function () {
            languageArray.push($(this)[0]['language']);
        });

        languageArray = unique(languageArray);


        $.ajax({
            url: '/ajax/swapTranslations',
            type: 'post',
            data: {
                'instance': instance,
                'productAttributeKey': productAttributeKey,
                'languages': languageArray,
                'formerData': inputArray
            }
        }).done(function (resp) {
            removeTableRows(table);
            insertTableRows(table, productAttributeKey, resp, languageArray);
        })
    });
}

function getInputData(inputs) {
    let inputsData = [];

    inputs.each(function () {
        let input = $(this);
        let inputData = {};
        inputData['language'] = input.data('language-id');
        inputData['productAttributeKey'] = input.data('key-id');
        inputData['defaultValue'] = input.data('default-value');
        inputData['value'] = input.val();
        inputsData.push(inputData);
    });

    return inputsData;
}

function removeTableRows(table, defaultValues, languageArray) {
    table.find('tbody tr').remove();
}

function insertTableRows(table, productAttributeKey, defaultValues, languages) {

    let tableContent = '';

    $.each(defaultValues, function (index) {
        let defaultValue = defaultValues[index];
        let tableDetails = '';

        $.each(languages, function (index) {
            let language = languages[index];
            tableDetails += `<td>${defaultValue}</td>`;
            tableDetails += `<td class="m-datatable__cell"><input class="form-control m-input" data-key-id="${productAttributeKey}" data-language-id="${language}" data-default-value="${defaultValue}" name="translations[${productAttributeKey}][${language}][${defaultValue}]" type="text"></td>`;
        });

        tableContent += `<tr>${tableDetails}</tr>`;
    });

    table.find('tbody').append(tableContent);
}

function unique(list) {
    var result = [];
    $.each(list, function (i, e) {
        if ($.inArray(e, result) == -1) result.push(e);
    });
    return result;
}



// WEBPACK FOOTER //
// ./resources/assets/js/contentElements/translation.js